import apiClient from './client';

export interface BillingMilestone {
  id: number;
  lead_id: number;
  name: string;
  amount: number;
  currency?: 'USD' | 'INR';
  due_date: string;
  status: 'pending' | 'paid' | 'overdue' | 'cancelled';
  paid_date?: string;
  paid_amount?: number;
  created_at: string;
  updated_at: string;
}

export interface BillingStatistics {
  totalPending: number;
  totalOverdue: number;
  totalPaid: number;
  upcomingMilestones: BillingMilestone[];
}

export const billingApi = {
  getAll: async (filters?: {
    leadId?: number;
    status?: string;
    startDate?: string;
    endDate?: string;
  }): Promise<BillingMilestone[]> => {
    const response = await apiClient.get<{ success: boolean; data: BillingMilestone[] }>('/billing', { params: filters });
    return response.data.data;
  },
  getByLeadId: async (leadId: number): Promise<BillingMilestone[]> => {
    const response = await apiClient.get<{ success: boolean; data: BillingMilestone[] }>(`/billing/lead/${leadId}`);
    return response.data.data;
  },
  getStatistics: async (): Promise<BillingStatistics> => {
    const response = await apiClient.get<{ success: boolean; data: BillingStatistics }>('/billing/statistics');
    return response.data.data;
  },
  getById: async (id: number): Promise<BillingMilestone> => {
    const response = await apiClient.get<{ success: boolean; data: BillingMilestone }>(`/billing/${id}`);
    return response.data.data;
  },
  create: async (milestone: Partial<BillingMilestone>): Promise<BillingMilestone> => {
    const response = await apiClient.post<{ success: boolean; data: BillingMilestone }>('/billing', milestone);
    return response.data.data;
  },
  update: async (id: number, milestone: Partial<BillingMilestone>): Promise<BillingMilestone> => {
    const response = await apiClient.patch<{ success: boolean; data: BillingMilestone }>(`/billing/${id}`, milestone);
    return response.data.data;
  },
  markAsPaid: async (id: number, paidAmount: number, paidDate?: string): Promise<BillingMilestone> => {
    const response = await apiClient.patch<{ success: boolean; data: BillingMilestone }>(`/billing/${id}/paid`, {
      paid_amount: paidAmount,
      paid_date: paidDate || new Date().toISOString().split('T')[0],
    });
    return response.data.data;
  },
  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/billing/${id}`);
  },
};
